var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCulsightLogoColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 492.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-10);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient-5);\r\n      }\r\n\r\n      .cls-6 {\r\n        fill: url(#linear-gradient-8);\r\n      }\r\n\r\n      .cls-7 {\r\n        fill: url(#linear-gradient-7);\r\n      }\r\n\r\n      .cls-8 {\r\n        fill: url(#linear-gradient-9);\r\n      }\r\n\r\n      .cls-9 {\r\n        fill: url(#linear-gradient-11);\r\n      }\r\n\r\n      .cls-10 {\r\n        fill: url(#linear-gradient-6);\r\n      }\r\n\r\n      .cls-11 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 68.18,
    y1: 321.68,
    x2: 1008.55,
    y2: 108.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3776e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2a99d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#a969fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#f55fcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#f97b7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffaa2a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 73.82,
    y1: 346.48,
    x2: 1014.18,
    y2: 132.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 73.3,
    y1: 344.18,
    x2: 1013.66,
    y2: 130.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 83.36,
    y1: 388.48,
    x2: 1023.73,
    y2: 174.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 87.85,
    y1: 408.23,
    x2: 1028.21,
    y2: 194.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 101.86,
    y1: 469.9,
    x2: 1042.22,
    y2: 256.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 95.12,
    y1: 440.25,
    x2: 1035.49,
    y2: 226.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 102.15,
    y1: 471.17,
    x2: 1042.51,
    y2: 257.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 45.3,
    y1: 220.95,
    x2: 985.66,
    y2: 7.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 61.9,
    y1: 294.05,
    x2: 1002.27,
    y2: 80.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 69.94,
    y1: 329.4,
    x2: 1010.3,
    y2: 115.73,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.97,348.63c-8.72,8.72-22.39,13.08-41,13.08s-32.83-5.49-44.27-16.47c-11.61-11.14-17.41-25.93-17.41-44.39s5.72-34.19,17.17-46.26c12.15-12.69,28.39-19.04,48.71-19.04,14.41,0,26.48,3.15,36.21,9.46l-4.67,29.91-.82-.12c-3.74-4.52-7.67-7.48-11.8-8.88-6.7-2.34-13.4-3.5-20.09-3.5s-11.96.86-15.77,2.57c-3.82,1.71-7.09,4.09-9.81,7.13-5.45,6.23-8.18,14.48-8.18,24.77,0,18.22,6.31,30.14,18.92,35.75,4.36,1.87,8.97,2.8,13.84,2.8s9.11-.43,12.73-1.28c3.62-.86,6.91-2.02,9.87-3.5,6.31-3.11,10.59-6.74,12.85-10.86l.82.35,2.69,28.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.7,349.33c-9.97,8.26-20.83,12.38-32.59,12.38-12.62,0-22.51-4.24-29.67-12.73-6.85-8.25-10.28-19.58-10.28-33.99v-46.38c0-15.58-.33-24.51-.99-26.81-.66-2.3-1.15-3.76-1.46-4.38,3.58.31,7.32.47,11.21.47h9.7c2.57,0,5.96-.12,10.16-.35v67.64c0,16.04,4.36,25.35,13.08,27.92,2.65.78,5.53,1.17,8.64,1.17,9.19,0,16.59-3.35,22.2-10.05v-86.33h28.97v107.12c0,6.85.31,11.84.93,14.95h-29.91v-10.63Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M401.24,346.88c0,6.7.16,11.06.47,13.08h-29.67v-174.06h29.2v160.97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M476.38,361.71c-21.96,0-38.51-4.01-49.65-12.03.16-2.34.39-4.98.7-7.94l1.05-8.41c.62-5.53,1.01-8.97,1.17-10.34.16-1.36.27-2.1.35-2.22.08-.12.7.51,1.87,1.87,1.17,1.36,3.39,3.02,6.66,4.96,3.27,1.95,7.05,3.66,11.33,5.14,9.27,3.19,18.92,4.79,28.97,4.79,13.47,0,20.21-4.48,20.21-13.43,0-2.88-1.29-5.02-3.86-6.43-4.6-2.34-11.35-4.11-20.27-5.31-8.92-1.21-16.22-2.98-21.9-5.32-5.69-2.34-10.32-5.14-13.9-8.41-6.62-6.15-9.93-14.21-9.93-24.18,0-12.15,4.67-21.69,14.02-28.62,9.27-6.85,22.08-10.28,38.43-10.28s30.02,4.6,41.47,13.78c-.55,2.03-1.13,3.97-1.75,5.84-1.79,5.14-3.12,8.84-3.97,11.1l-2.69,6.89c-.16.62-.27.93-.35.93-.16,0-.78-.82-1.87-2.45-4.91-5.68-12.54-9.42-22.9-11.21-3.19-.62-6.46-.93-9.81-.93-14.18,0-21.26,4.28-21.26,12.85,0,2.96,1.48,5.22,4.44,6.78,5.53,2.96,13.1,5.14,22.72,6.54,9.62,1.4,16.92,3.29,21.9,5.67,4.98,2.38,8.99,5.24,12.03,8.59,5.61,6.07,8.41,14.13,8.41,24.18,0,10.98-4.4,19.9-13.2,26.75-9.19,7.24-22,10.86-38.43,10.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M583.29,346.88c0,6.7.16,11.06.47,13.08h-29.67v-122.07h29.2v108.99Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M649.56,327.48c-2.88,3.82-4.32,6.83-4.32,9.05s.35,3.93,1.05,5.14c.7,1.21,2.22,2.36,4.56,3.45,5.14,2.41,13.59,4.54,25.35,6.37,11.76,1.83,20.97,4.11,27.63,6.83,6.66,2.73,12.05,6.07,16.18,10.05,7.71,7.55,11.56,18.26,11.56,32.12s-4.87,24.51-14.6,31.95c-9.74,7.44-24.18,11.16-43.34,11.16s-34.89-4.21-46.73-12.62c-11.84-8.41-17.91-19.59-18.22-33.53-.47-16.2,5.88-27.92,19.04-35.16-3.58-2.96-5.98-6.44-7.18-10.46-1.21-4.01-1.81-8.59-1.81-13.73,0-8.64,3.78-15.96,11.33-21.96-8.8-8.33-13.2-18.69-13.2-31.07,0-13.86,4.98-25.47,14.95-34.81,10.51-9.81,24.14-14.72,40.89-14.72,8.8,0,17.06,1.64,24.77,4.91,10.12-4.28,17.56-8.04,22.31-11.27,4.75-3.23,7.79-5.59,9.11-7.07l.7.12c.7,1.87,1.52,4.52,2.45,7.94l2.1,8.41c1.87,6.93,3,11.68,3.39,14.25-3.43,3.74-9.46,6.39-18.11,7.94,3.35,6.47,5.02,13.32,5.02,20.56s-1.25,13.8-3.74,19.68c-2.49,5.88-6.04,11.04-10.63,15.48-10.2,9.58-23.21,14.37-39.02,14.37-7.71,0-14.88-1.13-21.49-3.39ZM675.14,418.84c19.16,0,28.74-6.7,28.74-20.09,0-6.39-3.12-11.53-9.35-15.42-7.01-4.44-19.04-7.91-36.1-10.4l-6.07-1.05c-5.14,2.73-8.92,6.23-11.33,10.51-2.41,4.28-3.6,8.35-3.56,12.21.04,3.85.95,7.18,2.74,9.99,1.79,2.8,4.28,5.26,7.48,7.36,7.09,4.59,16.24,6.89,27.45,6.89ZM646.52,274.92c-1.09,2.8-1.64,5.65-1.64,8.53s.6,5.65,1.81,8.29c1.21,2.65,2.98,5.02,5.32,7.13,5.22,4.67,12.03,7.01,20.44,7.01,6.39,0,11.92-2.14,16.59-6.42,4.91-4.67,7.36-10.3,7.36-16.88s-2.22-11.9-6.66-15.95c-4.44-4.05-10.55-6.07-18.34-6.07-12.85,0-21.14,4.79-24.88,14.37Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M789.65,346.88c0,6.7.16,11.06.47,13.08h-29.09v-167.05h28.62v54.09c10.05-7.63,20.4-11.45,31.07-11.45,13.08,0,23.6,4.32,31.54,12.97,7.79,8.64,11.68,20.09,11.68,34.34v46.49c0,13.16.19,21.07.58,23.71.39,2.65.91,4.36,1.58,5.14.66.78,1.23,1.48,1.69,2.1l-.23.47c-6.31-.55-10.9-.82-13.78-.82h-8.29c-2.57,0-5.96.12-10.16.35v-67.64c0-10.75-2.38-18.69-7.13-23.83-3.58-3.89-8.45-5.84-14.6-5.84-9.11,0-17.1,5.26-23.95,15.77v68.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M952.75,334.26c10.05,0,16.94-2.61,20.68-7.83h.93l.35,27.1c-3.82,3.82-10.9,6.35-21.26,7.59-2.8.39-6.29.58-10.46.58s-8.68-.78-13.55-2.34c-4.87-1.56-9.01-4.09-12.44-7.59-7.09-7.24-10.63-18.57-10.63-33.99v-53.03h-17.64c-.08-2.26-.12-4.56-.12-6.89v-17.99c0-1.32.04-1.99.12-1.99h17.64v-33.29h28.62v33.29h32.12v26.87h-32.12v47.66c0,12.23,3.39,19.2,10.16,20.91,2.18.62,4.71.93,7.59.93Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M544.73,89.98l-64.42-35.58c-21.91-12.1-49.47-4.15-61.57,17.76l-10.03,18.15c-12.1,21.91-4.15,49.47,17.76,61.56l64.42,35.58c21.85,12.07,49.33,4.14,61.39-17.71l10.15-18.37c12.06-21.85,4.14-49.33-17.71-61.39ZM465.26,109.7c-10.25,18.56-27.54,28.65-38.62,22.53-11.07-6.12-11.74-26.12-1.49-44.68,10.25-18.56,27.54-28.65,38.62-22.54,11.07,6.12,11.74,26.13,1.49,44.69Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M618.68,155.09h0c3.61,25.5-9.7,50.41-32.91,61.58l-1.49.72-37.95-20.96.36-.32c17.96-16.27,29.95-38.08,34.05-61.97h0s37.95,20.96,37.95,20.96Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M651.66,186.63h0c.16,15.53-8.65,31.87-21.77,40.39l-.84.55-18.74-10.35.21-.23c10.68-11.31,18.56-25.64,22.39-40.71h0s18.74,10.35,18.74,10.35Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulsightLogoColored);
export default __webpack_public_path__ + "static/media/Culsight_Logo_Colored.b4006115fc0848f5ec77ead436ea4675.svg";
export { ForwardRef as ReactComponent };